import { initBloomreachTriggerBroker } from '@/shared/lib/bloomreach-bridge';

export const withBloomreachTriggerBroker = () => {
  initBloomreachTriggerBroker();
};
